import { createStore } from "vuex";
import { ModuleUser } from "./modules/moduleUser";
import { ModuleOrganization } from "./modules/moduleOrganization";
import { ModuleOrganizations } from "./modules/moduleOrganizations";
import { ModuleSurvey } from "./modules/moduleSurvey";
import { ModuleResults } from "./modules/moduleResults";
import { ModuleSurvey360 } from "./modules/moduleSurvey360";
import { ModuleTasksGoals } from "./modules/moduleTasksGoals";
import { ModuleInvitations } from "./modules/moduleInvitations";
import { ModuleMaterialBank } from "./modules/moduleMaterialBank";
import { ModuleDiscussions } from "./modules/moduleDiscussions";
import { ModuleDirectMessages } from "./modules/moduleDirectMessages";

export default new createStore({
  modules: {
    user: ModuleUser,
    organization: ModuleOrganization,
    organizations: ModuleOrganizations,
    survey: ModuleSurvey,
    results: ModuleResults,
    survey360: ModuleSurvey360,
    tasksGoals: ModuleTasksGoals,
    invitations: ModuleInvitations,
    materialBank: ModuleMaterialBank,
    discussions: ModuleDiscussions,
    directMessages: ModuleDirectMessages,
  },
  getters: {},
  mutations: {},
  actions: {},
});
